import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { getCategoryBySlug } from "@/mocks/categories";

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新购票指南
            </h2>
            <p className="text-foreground-600 text-sm">持续更新中，保持关注</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => {
            const category = getCategoryBySlug(article.categorySlug);
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    {category && (
                      <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full font-medium whitespace-nowrap">
                        {category.name}
                      </span>
                    )}
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {article.publishDate}
                    </span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {article.summary}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}